import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

import { pageHasHero } from '@/utils/page'

import { WPPageData } from '@/types'

type HeroLoaderContextValue = {
  hasHero: boolean
}

const HeroLoaderContext = createContext<HeroLoaderContextValue>({
  hasHero: false
})

type HeroLoaderProviderProps = PropsWithChildren<{
  pageProps: WPPageData
}>

const HeroLoaderProvider = ({
  pageProps,
  children
}: HeroLoaderProviderProps) => {
  const value = useMemo(
    () => ({ hasHero: pageHasHero(pageProps) }),
    [pageProps]
  )

  return (
    <HeroLoaderContext.Provider value={value}>
      {children}
    </HeroLoaderContext.Provider>
  )
}

export const useHeroLoaderContext = () => useContext(HeroLoaderContext)

export default HeroLoaderProvider
